// libs
import React, { memo } from 'react';

//components
import FiltersList from 'shared/components/Filter/components/FiltersList';
import CollapsedFilter from 'shared/components/Filter/components/CollapsedFilter';

//helpers
import { getUpdatedFilters } from 'shared/components/Filter/helpers';

//constants
import { FILTER_UI_TYPES } from 'shared/layouts/Listing/constants';

//styles
import { Wrapper } from './styles';

//defs
interface ListViewProps {
  filter: Listing.IFilter;
  onApplyClick: (value: string) => VoidFunction;
  checkedFilters: string[];
  isCollapsedView: boolean;
  onClick: () => VoidFunction;
}

function ListView({
  filter,
  onApplyClick,
  checkedFilters,
  isCollapsedView,
  onClick,
}: ListViewProps) {
  const { title, values, type } = filter;

  const onClickHandler = (item: string) => {
    const appliedValues = getUpdatedFilters(
      checkedFilters,
      filter.type === FILTER_UI_TYPES.MULT_SLECT,
      item
    );
    onApplyClick(appliedValues.join('_'));
  };

  return (
    <Wrapper isCollapsedView={isCollapsedView}>
      <CollapsedFilter
        title={title}
        isCollapsedView={isCollapsedView}
        onArrowClick={onClick}
        selectedFiltersCount={checkedFilters.length}
      />
      {!isCollapsedView && (
        <FiltersList
          selectedOptions={checkedFilters}
          values={values}
          onFilterSelection={onClickHandler}
          type={type}
        />
      )}
    </Wrapper>
  );
}

export default memo(ListView);
